import { Skeleton } from '@mui/material'

interface Props {
  element?: 'table' | 'small-table'
  rows?: number
}

const SkeletonLoader = ({ element, rows }: Props) => {
  const items = Array.from(
    { length: rows || element === 'table' ? 10 : 5 },
    (_, index) => index + 1,
  )

  switch (element) {
    case 'table': {
      return (
        <div>
          {items.map((item) => (
            <Skeleton height={64} key={item} />
          ))}
        </div>
      )
    }

    case 'small-table': {
      return (
        <div>
          {items.map((item) => (
            <Skeleton height={64} key={item} />
          ))}
        </div>
      )
    }

    default:
      return (
        <div>
          <Skeleton />
        </div>
      )
  }
}

export default SkeletonLoader
